import {
  NOTIFICATION_CLOSE,
  STACKED_NOTIFICATION_CLOSE,
  STACKED_NOTIFICATION_MODAL_SHOW,
  STACKED_NOTIFICATION_PAGE_SHOW,
} from '@common/actions/NotificationActions';

const initState = {
  modal: [],
  page: [],
};

const stackedNotificationsReducer = (state = initState, action) => {
  switch (action.type) {
    case STACKED_NOTIFICATION_PAGE_SHOW:
      return {
        ...state,
        page: {
          ...state.page,
          [action.payload.name]: {
            show: true,
            name: action.payload.name,
            extraArgs: action.payload.extraArgs,
          },
        },
      };
    case STACKED_NOTIFICATION_MODAL_SHOW:
      return {
        ...state,
        modal: {
          ...state.modal,
          [action.payload.name]: {
            show: true,
            name: action.payload.name,
            extraArgs: action.payload.extraArgs,
          },
        },
      };
    case STACKED_NOTIFICATION_CLOSE: {
      const newPage = { ...state.page };
      const newModal = { ...state.modal };
      delete newPage[action.payload.name];
      delete newModal[action.payload.name];
      return {
        ...state,
        page: newPage,
        modal: newModal,
      };
    }
    case NOTIFICATION_CLOSE:
      return initState;
    default:
      return state;
  }
};

export default stackedNotificationsReducer;
